"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scheduler = void 0;
var events_1 = require("events");
var helper_1 = require("@kcutils/helper");
var Scheduler = /** @class */ (function () {
    /**
     * @param interval time in millisecond
     * @param delay time in millisecond
     */
    function Scheduler(interval, delay) {
        var _this = this;
        if (delay === void 0) { delay = 0; }
        this.interval = interval;
        this.delay = delay;
        this.event = new events_1.EventEmitter();
        // add handle will process is exit
        process.on("exit", function () {
            _this.stop();
        });
    }
    Scheduler.prototype.on = function (type, cb) {
        this.event.on(type, cb);
    };
    Scheduler.prototype.schedule = function (cb) {
        var _this = this;
        this.event.emit("starting");
        this.cb = cb;
        this.onDelay = setTimeout(function () {
            _this.onSchedule = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 3, , 4]);
                            if (!this.isStartable())
                                throw new Error("cannot start because callback not exist");
                            this.event.emit("before-run");
                            _a = this.cb;
                            if (!_a) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.cb()];
                        case 1:
                            _a = (_b.sent());
                            _b.label = 2;
                        case 2:
                            _a;
                            this.event.emit("after-run");
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _b.sent();
                            this.event.emit("error", e_1);
                            return [3 /*break*/, 4];
                        case 4: return [2 /*return*/];
                    }
                });
            }); }, _this.interval);
        }, this.delay);
    };
    Scheduler.prototype.updateTime = function (interval, delay) {
        if (helper_1.generic.isNumber(interval))
            this.interval = interval;
        if (helper_1.generic.isNumber(delay))
            this.delay = delay;
    };
    /**
     * stop scheduler if it running and start new process
     */
    Scheduler.prototype.restart = function () {
        if (!this.cb)
            throw new Error("cannot get callback, you must call schedule first");
        this.stop();
        this.schedule(this.cb);
    };
    /**
     * return true if start the sehedule include when waiting for delay time
     */
    Scheduler.prototype.isStarting = function () {
        return helper_1.generic.isExist(this.onDelay) || this.isRunning();
    };
    /**
     * return true if and only if scheduler start, when delay time will return false
     */
    Scheduler.prototype.isRunning = function () {
        return helper_1.generic.isExist(this.onSchedule);
    };
    /**
     * return true if `schedule()` has been called
     */
    Scheduler.prototype.isStartable = function () {
        return helper_1.generic.isExist(this.cb);
    };
    /**
     * stop schedule process and delay process
     */
    Scheduler.prototype.stop = function () {
        this.onSchedule && clearInterval(this.onSchedule);
        this.onDelay && clearTimeout(this.onDelay);
        this.event.emit("stopped");
    };
    /**
     * remove all saved data
     */
    Scheduler.prototype.clear = function () {
        this.event.removeAllListeners();
        this.onSchedule = undefined;
        this.onDelay = undefined;
        this.cb = undefined;
    };
    return Scheduler;
}());
exports.Scheduler = Scheduler;
//# sourceMappingURL=Scheduler.js.map